<template>
    <div class="tmc-point-echarts">
        <div ref="tmcPointEcharts" style="width:1518px;height:700px;"></div>
    </div>
</template>
<script>
import Moment from 'moment';
import echarts from 'echarts';
export default {
    props: ['zoneinfo', 'zoneindex', 'time'],
    data() {
        return {
            mychart: {},
            timeBefore: '',
            xdata: ['', '', '', '', '', '', '', '', '', ''],
            ypdata: ['', '', '', '', '', '', '', '', '', ''],
            ycdata: ['', '', '', '', '', '', '', '', '', ''],
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    data: ['温度', '电流']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: this.xdata
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '温度',
                        position: 'left',
                        axisLine: {
                            lineStyle: {
                                color: '#f40'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} ℃'
                        }
                    },
                    {
                        type: 'value',
                        name: '电流',
                        position: 'right',
                        axisLine: {
                            lineStyle: {
                                color: '#675bba'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} A'
                        }
                    }
                ],
                series: [
                    {
                        name: '温度',
                        type: 'line',
                        data: this.ypdata
                    },
                    {
                        name: '电流',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.ycdata
                    }
                ]
            }
        };
    },
    mounted() {
        //获取DOM节点并初始化
        this.mychart = echarts.init(this.$refs.tmcPointEcharts);
        // 绘制图表
        this.mychart.setOption(this.option);
    },
    watch: {
        zoneindex: function(index) {
            this.xdata = ['', '', '', '', '', '', '', '', '', ''];
            this.ypdata = ['', '', '', '', '', '', '', '', '', ''];
            this.ycdata = ['', '', '', '', '', '', '', '', '', ''];
        },
        zoneinfo: function(info) {
            if (this.timeBefore != this.time) {
                this.timeBefore = this.time;
                this.xdata.shift();
                this.xdata.push(this.time);
                this.ypdata.shift();
                this.ypdata.push(info.p / 10);
                this.ycdata.shift();
                this.ycdata.push(info.c / 100);

                this.mychart.setOption({
                    xAxis: {
                        data: this.xdata
                    },
                    series: [
                        {
                            name: '温度',
                            data: this.ypdata
                        },
                        {
                            name: '电流',
                            data: this.ycdata
                        }
                    ]
                });
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/group/components/tmcPointEchat.vue